export default __webpack_public_path__ + "static/media/enable.5ffc7ccd.svg";